
export enum ShoppingCartMode {
  createOrEdit = 0,
  view = 1
}
